export const palette = {
  primary: {
    main: '#f16622',
    light: '#F3844E',
    dark: '#DE4F18',
    contrastText: '#FFFFFF',
  },
  custom: {
    grey: '#A9A9A9',
    grey100: '#f6f6f6',
    lightGrey: '#EEEEEE',
    extraLightGrey: '#D9D9D9',
    mediumGrey: '#757575',
    darkGrey: '#24242D',
    mediumDarkGrey: '#24242D80',
    white: '#FFFFFF',
    black: '#000000',
    greyBorder: '#24242dcc',
    darkGreyBorder: '#24242d66',
    lightOrange: '#f166221a',
    mediumGreen: '#00861D',
    blue: '#006EF3',
  },
  error: {
    main: '#ff0000',
  },
  collection: {
    blue: {
      d400: '#0063F3',
      d450: '#6A80FC',
    },
    grey: {
      d225: '#e8e8e8',
      d250: '#cccccc',
      d350: '#C8C8C8',
      d550: '#9E9EA6',
      d575: '#727276',
      d750: '#5b5b62',
    },
    green: {
      d850: '#00861d',
    },
    red: {
      d550: '#DA344D',
    },
    purple: {
      d500: '#7C3AED',
    },
    yellow: {
      d250: '#FCDD6A',
    },
  },
  orderStatusBackgroundColors: {
    request_submitted: 'rgba(252, 221, 106, 0.50)',
    order_confirmed: 'rgba(0, 134, 29, 0.50)',
    order_canceled: 'rgba(218, 52, 77, 0.50)',
    quote_created: 'rgba(0, 99, 243, 0.30)',
    apply_credit: 'rgba(36, 36, 45, 0.13)',
  },
} as const;
